<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

/* Sepete ekle butonu pasi yapma */

(function () {
  "use strict";

  /* =======================
     SELECTOR & AYARLAR
     ======================= */
  var FILE_INPUT_NAME_SELECTOR = 'input[type="file"][name="properties[Input File]"]';
  var ADD_BTN_SELECTOR = "button.pds-add";
  var OPT_SELECTOR = "button.pds-opt";

  var LOCK_CLASS = "file-gate-locked";
  var STYLE_ID = "file-gate-style";

  // Sadece: JPG/JPEG/PNG/PDF
  var ACCEPT_ATTR = "image/jpeg,image/png,application/pdf,.jpg,.jpeg,.png,.pdf";

  // Prüfungsform seçeneklerini tanımak için (Gesamt yazımı farklıysa diye “gesampt/gesapmt” de var)
  var EXAM_KEYWORDS = ["mundlich", "mündlich", "schriftlich", "gesamt", "gesampt", "gesapmt"];

  // Gate aktif olacak değer kontrolü (nur mündlich / nur schriftlich)
  function normalize(str) {
    str = (str || "").toString().trim().toLowerCase();
    if (str.normalize) {
      try { str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); } catch (e) {}
    }
    str = str.replace(/\s+/g, " ");
    return str;
  }

  function isGateVariant(value) {
    var v = normalize(value);
    // eşitlik yerine “içerir” kullandım: data değeri ekstra metin içerse de çalışsın
    return (v.indexOf("nur") !== -1) && (v.indexOf("mundlich") !== -1 || v.indexOf("schriftlich") !== -1);
  }

  function isExamOptionValue(value) {
    var v = normalize(value);
    for (var i = 0; i < EXAM_KEYWORDS.length; i++) {
      if (v.indexOf(EXAM_KEYWORDS[i]) !== -1) return true;
    }
    return false;
  }

  function closest(el, selector) {
    if (!el) return null;
    if (el.closest) return el.closest(selector);
    while (el && el.nodeType === 1) {
      if (el.matches && el.matches(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function injectCssOnce() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent =
      "button.pds-add." + LOCK_CLASS + "{" +
      "opacity:0.6 !important;" +
      "cursor:not-allowed !important;" +
      "}";
    document.head.appendChild(style);
  }

  /* =======================
     DOSYA KONTROL
     ======================= */
  function setAccept(input) {
    if (!input) return;
    if (input.getAttribute("accept") !== ACCEPT_ATTR) input.setAttribute("accept", ACCEPT_ATTR);
  }

  function isAllowedFile(file) {
    if (!file) return false;
    var type = (file.type || "").toLowerCase();

    // video kesin yasak
    if (type.indexOf("video/") === 0) return false;

    // mime type ile
    if (type === "application/pdf") return true;
    if (type === "image/jpeg") return true;
    if (type === "image/png") return true;

    // mime boşsa uzantı ile
    var name = (file.name || "").toLowerCase();
    return (
      name.endsWith(".pdf") ||
      name.endsWith(".jpg") ||
      name.endsWith(".jpeg") ||
      name.endsWith(".png")
    );
  }

  function hasValidFile(input) {
    return !!(input && input.files && input.files.length > 0 && isAllowedFile(input.files[0]));
  }

  /* =======================
     MESAJ
     ======================= */
  function getMessageText(kind) {
    var lang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
    var tr = {
      missing: "Lütfen önce JPG/PNG/PDF dosyası yükleyin.",
      invalid: "Bu dosya türüne izin verilmiyor. JPG/PNG/PDF yükleyin."
    };
    var de = {
      missing: "Bitte laden Sie zuerst eine JPG/PNG/PDF-Datei hoch.",
      invalid: "Dateityp nicht erlaubt. Bitte JPG/PNG/PDF hochladen."
    };
    var en = {
      missing: "Please upload a JPG/PNG/PDF file first.",
      invalid: "File type not allowed. Please upload JPG/PNG/PDF."
    };

    if (lang.indexOf("tr") === 0) return tr[kind] || tr.missing;
    if (lang.indexOf("de") === 0) return de[kind] || de.missing;
    return en[kind] || en.missing;
  }

  function getMessageEl(input) {
    if (!input) return null;
    var wrap = input.closest ? input.closest(".line-item-property__field") : null;
    if (!wrap) wrap = input.parentElement;
    if (!wrap) return null;

    var el = wrap.querySelector(".file-gate-message");
    if (!el) {
      el = document.createElement("div");
      el.className = "file-gate-message";
      el.setAttribute("role", "alert");
      el.style.marginTop = "8px";
      el.style.fontSize = "0.9em";
      wrap.appendChild(el);
    }
    return el;
  }

  function showMessage(input, kind) {
    var el = getMessageEl(input);
    if (el) el.textContent = getMessageText(kind);
  }

  function clearAllMessages() {
    var msgs = document.querySelectorAll(".file-gate-message");
    for (var i = 0; i < msgs.length; i++) msgs[i].remove();
  }

  /* =======================
     BUTON LOCK / UNLOCK
     ======================= */
  function lockVisual(btn) {
    if (!btn) return;
    btn.classList.add(LOCK_CLASS);
  }

  function unlockVisual(btn) {
    if (!btn) return;
    btn.classList.remove(LOCK_CLASS);

    // Geçmiş inline kalıntısı olasılığına karşı “temizle”
    btn.style.removeProperty("opacity");
    btn.style.removeProperty("cursor");
    btn.style.opacity = "";
    btn.style.cursor = "";
  }

  function unlockAllAddButtons() {
    var btns = document.querySelectorAll(ADD_BTN_SELECTOR);
    for (var i = 0; i < btns.length; i++) unlockVisual(btns[i]);
  }

  /* =======================
     PRÜFUNGSFORM STATE
     ======================= */
  var lastExamValue = null;   // tıklanan son Prüfungsform
  var gateActive = false;     // nur mündlich / nur schriftlich mi?

  function getOptValue(opt) {
    if (!opt) return "";
    return opt.getAttribute("data-pds-value") || (opt.dataset && opt.dataset.pdsValue) || opt.textContent || "";
  }

  function isOptSelected(opt) {
    if (!opt) return false;

    if (opt.getAttribute("aria-pressed") === "true") return true;
    if (opt.getAttribute("aria-selected") === "true") return true;

    if (opt.dataset) {
      if (opt.dataset.selected === "true" || opt.dataset.pdsSelected === "true" || opt.dataset.active === "true") return true;
    }

    if (opt.classList) {
      if (opt.classList.contains("active") || opt.classList.contains("is-active") ||
          opt.classList.contains("selected") || opt.classList.contains("is-selected")) return true;
    }

    return false;
  }

  function detectExamValueFromDom() {
    var opts = document.querySelectorAll(OPT_SELECTOR);
    for (var i = 0; i < opts.length; i++) {
      var v = getOptValue(opts[i]);
      if (!isExamOptionValue(v)) continue;
      if (isOptSelected(opts[i])) return v;
    }
    return null;
  }

  function computeGateActive() {
    // Öncelik: son tıklanan
    var v = lastExamValue || detectExamValueFromDom();
    if (!v) return false; // tespit edemezsek yanlışlıkla kilitlemeyelim
    return isGateVariant(v);
  }

  /* =======================
     BUTTON <-> FILE INPUT EŞLEME
     (id pattern: pds-add-BASE  <->  BASE-input-file)
     ======================= */
  function findFileInputForButton(btn) {
    if (!btn) return null;

    // 1) id ile türet
    if (btn.id && btn.id.indexOf("pds-add-") === 0) {
      var base = btn.id.replace(/^pds-add-/, "");
      var byId = document.getElementById(base + "-input-file");
      if (byId) return byId;
    }

    // 2) form içinde name selector ile
    var form = btn.closest ? btn.closest("form") : null;
    if (form) {
      var inForm = form.querySelector(FILE_INPUT_NAME_SELECTOR);
      if (inForm) return inForm;

      // 3) form içinde herhangi bir file input fallback
      var anyFile = form.querySelector('input[type="file"]');
      if (anyFile) return anyFile;
    }

    // 4) sayfa genel fallback
    return document.querySelector(FILE_INPUT_NAME_SELECTOR) || document.querySelector('input[type="file"]');
  }

  /* =======================
     APPLY (en kritik kısım)
     - Gesamt: KESİN unlock (class sil)
     - nur*: file yoksa lock
     ======================= */
  function applyState() {
    gateActive = computeGateActive();

    // Gesamt seçiliyse: file input’a bakmadan class’ı KESİN kaldır
    if (!gateActive) {
      unlockAllAddButtons();
      clearAllMessages();
      return;
    }

    // Gate aktif: butonları file durumuna göre lock/unlock yap
    var btns = document.querySelectorAll(ADD_BTN_SELECTOR);
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var input = findFileInputForButton(btn);
      if (input) setAccept(input);

      if (input && hasValidFile(input)) {
        unlockVisual(btn);
      } else {
        lockVisual(btn);
      }
    }
  }

  function applySoon() {
    applyState();
    setTimeout(applyState, 50);
    setTimeout(applyState, 200);
  }

  /* =======================
     FAIL-SAFE: Gesamt modunda
     class tekrar eklenirse anında kaldır
     ======================= */
  function observeAddButtons() {
    if (!window.MutationObserver) return;

    var btns = document.querySelectorAll(ADD_BTN_SELECTOR);
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];

      if (btn.dataset && btn.dataset.fileGateObserved === "1") continue;
      if (btn.dataset) btn.dataset.fileGateObserved = "1";

      (function (b) {
        var mo = new MutationObserver(function () {
          // Gesamt modundaysak, lock class’ı asla kalmasın
          if (!gateActive && b.classList.contains(LOCK_CLASS)) {
            unlockVisual(b);
          }
        });
        mo.observe(b, { attributes: true, attributeFilter: ["class", "style"] });
      })(btn);
    }
  }

  /* =======================
     EVENTLER
     ======================= */

  // 1) Prüfungsform tıklanınca (Gesamt dahil) state güncelle
  document.addEventListener("click", function (e) {
    var opt = closest(e.target, OPT_SELECTOR);
    if (!opt) return;

    var val = getOptValue(opt);
    if (!isExamOptionValue(val)) return;

    lastExamValue = val;
    applySoon();
  }, true);

  // 2) Dosya seçimi: tür doğrula + state güncelle
  document.addEventListener("change", function (e) {
    var input = e.target;
    if (!input || !input.matches) return;

    // Name selector tutmuyorsa da yakalayalım: type=file ise kabul
    if (input.matches(FILE_INPUT_NAME_SELECTOR) || input.matches('input[type="file"]')) {
      setAccept(input);

      if (input.files && input.files.length > 0) {
        if (!isAllowedFile(input.files[0])) {
          showMessage(input, "invalid");
          input.value = "";
        }
      }
      applySoon();
    }
  }, true);

  // 3) Sepete ekle tıklanınca: gate aktif ve dosya yoksa engelle
  document.addEventListener("click", function (e) {
    var btn = closest(e.target, ADD_BTN_SELECTOR);
    if (!btn) return;

    applyState(); // her tıklamada güncel state

    if (!gateActive) {
      // Gesamt: görünüm kesin normal olsun
      unlockVisual(btn);
      return;
    }

    var input = findFileInputForButton(btn);
    if (input) setAccept(input);

    if (!input || !hasValidFile(input)) {
      e.preventDefault();
      e.stopImmediatePropagation();

      lockVisual(btn);
      if (input) {
        showMessage(input, "missing");
        try { input.scrollIntoView({ behavior: "smooth", block: "center" }); } catch (err) {}
        try { input.focus({ preventScroll: true }); } catch (err2) {}
      }
    }
  }, true);

  // 4) Submit güvenliği
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || form.nodeName !== "FORM") return;

    applyState();
    if (!gateActive) return;

    var input = form.querySelector(FILE_INPUT_NAME_SELECTOR) || form.querySelector('input[type="file"]');
    if (input) setAccept(input);

    if (!input || !hasValidFile(input)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (input) showMessage(input, "missing");
    }
  }, true);

  /* =======================
     INIT
     ======================= */
  function init() {
    injectCssOnce();

    // başlangıçta seçili exam değerini DOM’dan al (varsa)
    lastExamValue = detectExamValueFromDom() || lastExamValue;

    // accept düzelt
    var inputs = document.querySelectorAll(FILE_INPUT_NAME_SELECTOR);
    for (var i = 0; i < inputs.length; i++) setAccept(inputs[i]);

    observeAddButtons();
    applySoon();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);

})();

/* Sepete ekleme butonu pasif yapma */



/* Casablanca koleksiyonunda menü gizleme  

(function () {
  // URL "casablanca" içeriyor mu?
  var isCasablanca = /casablanca/i.test(window.location.href);

  function norm(s) {
    return (s || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }
  var label = norm("telc Prüfungen");

  function setVisible(el, visible) {
    if (visible) {
      el.style.removeProperty("display");
    } else {
      el.style.setProperty("display", "none", "important");
    }
  }

  function apply() {
    document.querySelectorAll("li.chs-item.chs-has-sub").forEach(function (li) {
      var a = li.querySelector(":scope > a.chs-link") || li.querySelector("a.chs-link");
      if (a && norm(a.textContent) === label) {
        setVisible(li, !isCasablanca); // Casablanca'da gizle, diğerlerinde göster
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", apply, { once: true });
  } else {
    apply();
  }
  new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
})();



(function () {
  // URL "casablanca" içeriyor mu?
  var isCasablanca = /casablanca/i.test(window.location.href);

  // Metinleri güvenli karşılaştırmak için normalize et (ü -> u, boşlukları temizle)
  function norm(s) {
    return (s || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }
  var label = norm("telc Prüfung Casablanca");

  function setVisible(el, visible) {
    if (visible) {
      el.style.removeProperty("display");
    } else {
      el.style.setProperty("display", "none", "important");
    }
  }

  function apply() {
    document.querySelectorAll("li.chs-item.chs-has-sub").forEach(function (li) {
      var a = li.querySelector(":scope > a.chs-link") || li.querySelector("a.chs-link");
      if (a && norm(a.textContent) === label) {
        setVisible(li, isCasablanca); // Sadece casablanca'da göster
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", apply, { once: true });
  } else {
    apply();
  }
  new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
})();


/* Casablanca koleksiyonunda menü gizleme */